<template>
    <div class="auth-fail">
        <p>There was problem with the logged in account, please log out and try again</p>
        <md-button v-if="!$auth.loading && $auth.isAuthenticated" 
                   @click="logout" class="md-primary md-round" title="Log Out of UnitView">Log out</md-button>
    </div>
</template>

<script>
    export default {
        name: 'AuthFail',
        methods: {
            logout() {

                this.$auth.logout({
                    returnTo: window.location.origin
                });
            },
        }
    };
</script>

<style scoped>
    .auth-fail {
        text-align: center;
        padding-top: 20vh;
        padding-bottom: 20vh;
    }
</style>
